import { create } from 'zustand';
export const useGameStore = create((set) => ({
    // Auth
    token: localStorage.getItem('token'),
    user: null,
    isLoggedIn: !!localStorage.getItem('token'),
    // Game Data
    cards: [],
    userCards: [],
    teams: [],
    currentTeam: null,
    announcements: [],
    // Actions
    setToken: (token) => {
        localStorage.setItem('token', token);
        set({ token, isLoggedIn: true });
    },
    setUser: (user) => set({ user }),
    logout: () => {
        localStorage.removeItem('token');
        set({ token: null, user: null, isLoggedIn: false });
    },
    setCards: (cards) => set({ cards }),
    setUserCards: (cards) => set({ userCards: cards }),
    setTeams: (teams) => set({ teams }),
    setCurrentTeam: (team) => set({ currentTeam: team }),
    setAnnouncements: (announcements) => set({ announcements }),
    // Battle State
    inBattle: false,
    battleState: null,
    startBattle: () => set({ inBattle: true }),
    endBattle: () => set({ inBattle: false, battleState: null }),
    setBattleState: (state) => set({ battleState: state }),
    // UI State
    currentPage: 'home',
    setCurrentPage: (page) => set({ currentPage: page }),
}));
